import { JSX } from 'react';
export const FilledCheckIcon = ({ fill }: { fill?: string }): JSX.Element => {
  const color = fill || '#1c49c2';
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      focusable="false"
      aria-hidden="true"
      data-a11y="decorative"
    >
      <path
        d="M7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM6.19301 10.8602L3.79967 8.46683C3.53967 8.20683 3.53967 7.78683 3.79967 7.52683C4.05967 7.26683 4.47967 7.26683 4.73967 7.52683L6.66634 9.44683L11.253 4.86016C11.513 4.60016 11.933 4.60016 12.193 4.86016C12.453 5.12016 12.453 5.54016 12.193 5.80016L7.13301 10.8602C6.87967 11.1202 6.45301 11.1202 6.19301 10.8602Z"
        fill={color}
      />
    </svg>
  );
};
